"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ["AMERICAS", "APAC-ANZ", "APAC-ASEAN", "APAC-Greater China", "APAC-India", "APAC-Korea", "Corporate", "EMEA", "JAPAN", "LAC", "North America"];
exports.default = _default;
//# sourceMappingURL=geo_region_source.js.map